{
  "An unknown error occurred. Please refresh the page and try again.": "An unknown error occurred. Please refresh the page and try again.",
  "Back to Sign In": "Back to Sign In",
  "Back to login": "Back to login",
  "Cancel": "Cancel",
  "Change Sign In Method": "Change Sign In Method",
  "Change user": "Change user",
  "Change verification method": "Change verification method",
  "Checking Status...": "Checking Status...",
  "Checking...": "Checking...",
  "Continue": "Continue",
  "Continue to SSO Login": "Continue to SSO Login",
  "Didn’t get your code? ": "Didn’t get your code? ",
  "Email": "Email",
  "Enter email": "Enter email",
  "Enter team identifier": "Enter team identifier",
  "Enter the email address associated with your account, and we'll send you a link to reset your password.": "Enter the email address associated with your account, and we'll send you a link to reset your password.",
  "Error Description:": "Error Description:",
  "Error resetting your password": "Error resetting your password",
  "Failed to send the password reset link": "Failed to send the password reset link",
  "Forgot password?": "Forgot password?",
  "Forgot your password?": "Forgot your password?",
  "Having trouble? ": "Having trouble? ",
  "If the Weave app didn't open, try signing in again from the Weave app.": "If the Weave app didn't open, try signing in again from the Weave app.",
  "If your email matches a registered account, you will have received instructions on how to regain access. You can also reset your password.": "If your email matches a registered account, you will have received instructions on how to regain access. You can also reset your password.",
  "If your user credentials exist in our system, we have sent you a password reset link via email.": "If your user credentials exist in our system, we have sent you a password reset link via email.",
  "Incorrect credentials. Please try again": "Incorrect credentials. Please try again",
  "Invalid login credentials.": "Invalid login credentials.",
  "Learn how to manage MFA in the <2>Help Center</2>.": "Learn how to manage MFA in the <2>Help Center</2>.",
  "Let's update your password!": "Let's update your password!",
  "Log In": "Log In",
  "Log In with Passkey": "Log In with Passkey",
  "Log In with SSO": "Log In with SSO",
  "Log in to your Weave account": "Log in to your Weave account",
  "Log in with SSO": "Log in with SSO",
  "Logging in...": "Logging in...",
  "Logging out...": "Logging out...",
  "Login failed. Please try again": "Login failed. Please try again",
  "Multi-factor authentication is not supported in this login flow. Disable MFA for this user in WAM.": "Multi-factor authentication is not supported in this login flow. Disable MFA for this user in WAM.",
  "No worries, we'll send you reset instructions": "No worries, we'll send you reset instructions",
  "Our team has been notified, and we are working to resolve the issue as quickly as possible. Please try again later. If the problem persists, please contact Customer Support at (888) 579-5668 for further assistance.": "Our team has been notified, and we are working to resolve the issue as quickly as possible. Please try again later. If the problem persists, please contact Customer Support at (888) 579-5668 for further assistance.",
  "Passkey name": "Passkey name",
  "Password": "Password",
  "Proceed with SSO": "Proceed with SSO",
  "Remember me": "Remember me",
  "Reset Password": "Reset Password",
  "Select a Verification Method": "Select a Verification Method",
  "Send a new code": "Send a new code",
  "Sending new code...": "Sending new code...",
  "Sending password reset email": "Sending password reset email",
  "Set up new passkey": "Set up new passkey",
  "Show advanced details": "Show advanced details",
  "Sign In": "Sign In",
  "Signing in": "Signing in",
  "Submit": "Submit",
  "Success": "Success",
  "Team Identifier": "Team Identifier",
  "The reset password has been sent to": "The reset password has been sent to",
  "The reset password link has been sent to {{value}}": "The reset password link has been sent to {{value}}",
  "The verification code you entered is incorrect. Please check your code and try again.": "The verification code you entered is incorrect. Please check your code and try again.",
  "There was an error initializing the login process. Please refresh the page and try again.": "There was an error initializing the login process. Please refresh the page and try again.",
  "There was an error processing your consent. Please refresh the page and try again.": "There was an error processing your consent. Please refresh the page and try again.",
  "There was an error with your passkey. Please try again.": "There was an error with your passkey. Please try again.",
  "This password has been associated with a previous data breach. Please choose a different password to protect your account.": "This password has been associated with a previous data breach. Please choose a different password to protect your account.",
  "Verifying code...": "Verifying code...",
  "Verifying...": "Verifying...",
  "We Emailed You a Code": "We Emailed You a Code",
  "We Texted You a Code": "We Texted You a Code",
  "We could not find a tenant with that identifier.": "We could not find a tenant with that identifier.",
  "We could not set up your passkey.": "We could not set up your passkey.",
  "We encountered some issue while navigating to the Log In page. Please try again.": "We encountered some issue while navigating to the Log In page. Please try again.",
  "We were unable to send the verification code. Please try again.": "We were unable to send the verification code. Please try again.",
  "We've detected that this password matches one found in a public database of exposed passwords. To protect your account, please create a new password.": "We've detected that this password matches one found in a public database of exposed passwords. To protect your account, please create a new password.",
  "Welcome back": "Welcome back",
  "You can close this window.": "You can close this window.",
  "You're signed in": "You're signed in",
  "Your IP address ({{ip}}) is restricted from accessing this resource. Please contact your Weave administrator if you think this is an error.": "Your IP address ({{ip}}) is restricted from accessing this resource. Please contact your Weave administrator if you think this is an error.",
  "email": "email"
}
